import { cn } from '@/utils/utils';
import { useTranslation } from 'react-i18next';

const DeletedLabel = ({ className = '' }) => {
    // hook
    const { t } = useTranslation();
    return (
        <span className={cn(
            'whitespace-nowrap inline-block border border-[#929292] px-1 py-[2px] rounded-[6px] font-normal text-fs-mid14 leading-lh-nor14 text-[#929292]',
            className
        )}
        >
            {t('sentences.deleted')}
        </span>
    );
};

export default DeletedLabel;
